import PropTypes from 'prop-types'

import * as S from './styled'

const Shell = ({ width = '100%', height = 'auto', borderRadius = null }) => (
  <S.Shell width={width} height={height} borderRadius={borderRadius} />
)

Shell.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isRounded: PropTypes.oneOf(['kilo', 'mega', 'giga', 'tera', 'circle'])
}

export default Shell
